export const randomNameFactory = () => {
  let nonameId = 0
  return () => `NO_NAME_FIELD_$${nonameId++}`
}
